<script>
    export default {
        name: 'design-2021-assignment-edit-select-lesson-modal-component',
        props: {
            assignmentIn: Object
        },
        data() {
            return {
                selectedLesson: this.assignmentIn.lesson ?? null,
                lessons: [],
                modal: false
            };
        },
        methods: {
            show() {
                if (!this.lessons.length) {
                    this.axios
                        .get(this.routes.getLessonsForAssignment(this.assignmentIn.id)).then(
                        (response) => {
                            this.lessons = response.data;
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        }
                    );
                }

                this.modal = true;
            },

            onOk() {
                let data = {
                    lesson_id: this.selectedLesson.id
                };

                this.axios
                    .post(this.routes.setLessonForAssignment(this.assignmentIn.id), data).then(
                    (response) => {
                        this.$emit('assignment-updated', response.data);
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            }
        }
    };
</script>

<template>
    <b-modal
        id="select-lesson-modal"
        :title="$t('assignment.select_lesson')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        v-model="modal"
        @ok="onOk"
        size="m"
        modal-class="apprentice-default-modal">

        <design-2021-apprentice-multiselect-component
            v-model="selectedLesson"
            :multiple-select="false"
            label="title"
            :options="lessons"
            :placeholder="$t('assignment.select_corresponding_lesson')">
        </design-2021-apprentice-multiselect-component>
    </b-modal>
</template>

<style scoped lang="scss">

</style>